// Ref-counted registry: multiple ObjectDetailsPanel instances for the same objectType
// (e.g. the actual page + the PageEditor preview) all register independently.
// The key stays in the map until ALL instances unregister.
const mounted = new Map();
const listeners = new Set();
function notify() {
    listeners.forEach(l => l());
}
export function registerMountedObjectType(objectType) {
    const key = objectType.toLowerCase();
    mounted.set(key, (mounted.get(key) || 0) + 1);
    notify();
}
export function unregisterMountedObjectType(objectType) {
    const key = objectType.toLowerCase();
    const count = mounted.get(key) || 0;
    if (count <= 1) {
        mounted.delete(key);
    }
    else {
        mounted.set(key, count - 1);
    }
    notify();
}
export function getMountedObjectTypes() {
    return Array.from(mounted.keys());
}
export function hasMountedObjectTypes() {
    return mounted.size > 0;
}
export function onMountedTabsChange(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
